export const MODALS = {
    upsertCategory: 'upsertCategory',
    deleteCategory: 'deleteCategory',
};

export const MODAL_EVENTS = {
    CATEGORY_CREATE: 'guide-category:create',
    CATEGORY_UPDATE: 'guide-category:update',
    CATEGORY_DELETE: 'guide-category:delete',
};
